<button [ngClass]="css" type="button" (click)="openHelperPopup()" attr.aria-label="{{'GLOBAL.HELP' | translate }}: {{title | translate}}">
    <span [ngClass]="icss" class="fa-stack" style="pointer-events: none;"> <i class="fas fa-circle fa-stack-1x"></i> <i class="fas fa-question-circle fa-stack-1x fa-inverse"></i> </span>
</button>
